// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3lahn","head":"Table_head__ZCFuT","col":"Table_col__2gtQC"};